import { Component, OnInit } from "@angular/core";
import {
  ActivatedRoute,
  Router,
  NavigationStart,
  Event
} from "@angular/router";
import { GlobalsService } from "./shared/services";
import { LoadingGlobalService } from "./shared/components";
import { TranslateService } from "@ngx-translate/core";
import { AuthService } from "./shared/services/auth-service.service";
import { filter, map } from "rxjs/operators";
import { Observable } from "rxjs";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"]
})
export class AppComponent implements OnInit {

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private globals: GlobalsService,
    private loadingService: LoadingGlobalService,
    private translate: TranslateService,
    private evaluation: AuthService,
  ) {
    const navStartEvents$: Observable<NavigationStart> = this.router.events.pipe(
      filter((evt: Event) => evt instanceof NavigationStart),
      map((evt: Event) => evt as NavigationStart)
    );

    navStartEvents$.subscribe((evt: NavigationStart) => {
      window.scroll(0, 0);
    });
  }

  ngOnInit() {
    this.translate.setDefaultLang("es");
    this.loadingService.show();
    this.activatedRoute.queryParams.subscribe(params => {
      // console.log(params);
      //   debugger;
      if (params.code) {
        // console.log(params.code);
        // console.log("entre");
        const convert = decodeURIComponent(escape(window.atob(params.code)));
        const data = JSON.parse(convert);

        // console.log(data)

        this.globals.setDataFirst({
          user: data.user,
          organization: data.organization
        });

        sessionStorage.setItem("activeUser", JSON.stringify(data.user));
        sessionStorage.setItem(
          "organization",
          JSON.stringify(data.organization)
        );

        this.globals.setUser(data.user);
        this.globals.setOrg(data.organization);

        if (params.data) {
          // console.log(params.data);
          const dataSplit = params.data.split(/\s/g);

          let convertNC
          if (dataSplit.length > 1) {
            convertNC = decodeURIComponent(
              escape(window.atob(dataSplit.join("+")))
            );
          } else {
            convertNC = decodeURIComponent(
              escape(window.atob(dataSplit[0]))
            );
          }
          const dataNC = JSON.parse(convertNC);
          console.log(dataNC);
          this.evaluation.setEval(dataNC);
        //  this.loadingService.hide();
          this.router.navigate(["/gid/process-maps"]);
          // this.router.navigate(["/gnc"]);
        } else {
        //  this.loadingService.hide();
          this.router.navigate(["/gid"]);
        }
      }
    });
  }
}
